module.exports = __webpack_public_path__ + "fonts/0249f3b8683160e2defa91cedd6b3f6b.txt";